export const ENTITY_DEFAULT_RENDER_STRING = "$$entity_name$$ - $$owner_name$$ $$owner_last_name$$";
export const ENTITY_QUESTION_PDF_KEYS = {
  '$$entity_id$$': "entityId",
  '$$entity_name$$': "entityName",
  '$$owner_name$$': "entityOwnerName",
  '$$owner_last_name$$': "entityOwnerLastName",
  '$$owner_phone$$': "entityOwnerPhone",
  '$$owner_email$$': "entityOwnerEmail",
  '$$owner_id$$': "entityOwnerId"
}

export const MAP_CENTER = {
    lat: 6.269229,
    lng: -75.569479
}

export const DELIMITATION_DESCRIPTORS=["lng", "lat", "group", "type", "color"]